/**
 * TermsOfServicePage — renders the counsel-drafted Terms of Service.
 *
 * The actual text comes from `legal/Xpert_Terms_of_Service.docx` and is
 * extracted at build time by `bin/extract_legal_docs.py` into the
 * `legal-rendered/` directory.
 *
 * Editing the page text: edit the docx, run `python bin/extract_legal_docs.py`,
 * then bump the version row in `legal_audit.policy_versions` if the change
 * is substantive.
 */
import LegalDocViewer from "@/components/LegalDocViewer";
import termsContent from "@/legal-rendered/terms_of_service";

export default function TermsOfServicePage() {
  return (
    <LegalDocViewer
      title="Terms of Service"
      subtitle="Marketplace user terms (B2C + B2B)"
      policyId="terms_of_service"
      policyVersion="1.1.0"
      content={termsContent}
    />
  );
}
